import React, { Component } from "react";
import {Helmet} from 'react-helmet'

class PageHelmet extends Component{
    render(){
        return(
            <React.Fragment>
                <Helmet>
                    <title>Nearl | {this.props.pageTitle}</title>
                    <meta name="description" content="Desarrollamos aplicaciones personalizadas a nivel internacional con un compromiso inquebrantable hacia la calidad y la satisfacción del cliente. ¡Confía en nosotros para llevar tu visión digital al siguiente nivel!" />
                </Helmet>
            </React.Fragment>
        )
    }
}


export default PageHelmet;
